module.exports = __webpack_public_path__ + "static/1-086fad42b947ec29369ee2120b3f8950.jpg";